import React, { createContext, useContext, useState, useCallback, useMemo, useEffect } from "react";

const HeaderContext = createContext(null);

export function HeaderProvider({ children }) {
    const [header, setHeaderState] = useState({
        content: null,
    });

    const setHeader = useCallback((next) => {
        setHeaderState({
            content: next.content ?? null
        });
    }, []);

    const resetHeader = useCallback(() => {
        setHeaderState({ content: null });
    }, []);

    const value = useMemo(
        () => ({ header, setHeader, resetHeader }),
        [header, setHeader, resetHeader]
    );

    return <HeaderContext.Provider value={value}>{children}</HeaderContext.Provider>;
}

export function useHeader() {
    const ctx = useContext(HeaderContext);
    if (!ctx) throw new Error("useHeader must be used within a HeaderProvider");
    return ctx.header;
}

export function usePageHeader(content, deps = []) {
    const ctx = useContext(HeaderContext);
    if (!ctx) throw new Error("usePageHeader must be used within a HeaderProvider");
    const { setHeader, resetHeader } = ctx;

    useEffect(() => {
        setHeader({ content });
    }, deps);

    // Clear header only when the page unmounts, not on every dep change
    useEffect(() => {
        return () => resetHeader();
    }, []);
}